import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { CompagnieComponent } from 'src/app/anagrafiche/compagnie/compagnie.component';
import { Compagnia } from 'src/app/models/compagnia';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Model } from 'src/app/models/model';
import { takeUntil } from 'rxjs/operators';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => CompagniaPickerComponent) },
  ],
  selector: 'compagnia-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class CompagniaPickerComponent extends ExternalSelectorComponent {

  @Input() multipleSelection = false;
  @Output() selectedCompagnieChange = new EventEmitter<Compagnia[]>();

  selectedCompagnie: Compagnia[] = [];
  onChange: any;
  
  @Input()
  get externalEntityObserver(): Observable<any> {
    const picked = this.dialog.open(CompagnieComponent, { 
      data: { 
        selectionMode: !this.multipleSelection, 
        multipleSelection: this.multipleSelection, 
        showReset: true 
      } 
    }).afterClosed();
    
    return picked;
  }

  parts: FormGroup = this.fb.group({
    humanIdentifier: [''],
    id: [''],
  });

  query: FormGroup = this.fb.group({
    states: new FormArray([])
  });

  registerOnChange(onChange: (value: Model | null) => void): void {
    if (this.multipleSelection) {
      this.query.valueChanges.pipe(
        takeUntil(this.destroy),
      ).subscribe((value) => { 
        if (value.states) onChange(value.states);
      });
    } else {
      this.parts.valueChanges.pipe(
        takeUntil(this.destroy),
      ).subscribe((value) => {
        if (value.id) {
          onChange(value);
        } else {
          onChange(null);
        }
      });
    }
  }

  public writeValue(value?: any): any {
    if (value === null || value === undefined) {
      this.parts.reset();
      const statesArray = this.query.get('states') as FormArray;
      statesArray.clear();
      this.selectedCompagnie = [];
      this.selectedCompagnieChange.emit(this.selectedCompagnie);
      this.stateChanges.next();
    }
    else if (this.multipleSelection) {
      const deserializedItems = value.map(item => new Compagnia().deserialize(item));
      const states = new FormArray(deserializedItems.map(item => new FormControl(item.id)));

      this.parts.patchValue({
        humanIdentifier: deserializedItems.map(item => item.humanIdentifier || item.nome).join(', '),
        id: deserializedItems.map(item => item.id)
      });

      this.selectedCompagnie = deserializedItems;
      this.selectedCompagnieChange.emit(this.selectedCompagnie);
      this.query.setControl('states', states);
      this.stateChanges.next();
    } else {
      if (value && typeof value === 'object') {
        this.parts.patchValue({
          humanIdentifier: value.humanIdentifier || value.nome || '',
          id: value.id
        });
      } else {
        this.parts.patchValue({
          humanIdentifier: '',
          id: value
        });
      }
      this.stateChanges.next();
    }
  }

  protected handleSelection(selectedValue: any): void {
    if (selectedValue) {
      if (this.multipleSelection) {
        this.writeValue(selectedValue);
      } else {
        const compagnia = new Compagnia().deserialize(selectedValue);
        this.writeValue(compagnia);
        
        if (this.onChange) {
          this.onChange(compagnia);
        }
      }
    }
  }
}